export default __webpack_public_path__ + "static/media/footer.44c30585.png";